import AnalyticsAbstract from "@MAIN/modules/Analytics/Abstract";
import * as Sentry from "@sentry/browser";

export default class Gtag extends AnalyticsAbstract {
  constructor() {
    super()

    const UA = process.env.MIX_GOOGLE_UA

    function getRetailCrmCookie(name) {
      var matches = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return matches ? decodeURIComponent(matches[1]) : '';
    }

    if (!window.gtag) {
      Sentry.captureMessage(`gtag not found for type: ${type}`);
      return;
    }

    global.gtag('js', new Date());

    global.gtag('config', UA, {
      'send_page_view': false,
    });

    global.gtag('consent', 'default', {
      'ad_storage': 'granted',
      'analytics_storage': 'granted'
    });

    global.gtag('event', 'page_view', {
      'dimension1': getRetailCrmCookie('_ga'),
    });
  }

  event(target, params = {}) {
    this.log(`[GTAG] event: ${target}`, params)
    window.gtag('event', target, params);
  }
}
